export interface OrbitClientPanelConnectionIssue {
  kind: "setup_required" | "session" | "unknown";
  title: string;
  description: string;
  detail: string;
  actionLabel: string;
}

export function normalizeConnectionIssue(err: unknown): OrbitClientPanelConnectionIssue {
  const raw = err instanceof Error ? err.message : String(err || "");
  const clean = raw.replace(/^orbit-bridge:\s*/i, "");
  if (!raw) {
    return {
      kind: "unknown",
      title: "Orbit is not connected",
      description: "Retry the connection after the dashboard has finished loading.",
      detail: "Orbit Bridge is not connected yet.",
      actionLabel: "Retry",
    };
  }
  if (raw.includes("ORBIT_BRIDGE_SIGNING_SECRET")) {
    return {
      kind: "setup_required",
      title: "Bridge setup required",
      description: "The Orbit widget is installed, but this dashboard still needs its server-side signing secret configured.",
      detail: "Set ORBIT_BRIDGE_SIGNING_SECRET in the client Supabase secrets, then redeploy orbit-bridge-token.",
      actionLabel: "Retry after deploy",
    };
  }
  if (raw.includes("404") || raw.includes("token failed") || raw.includes("token route")) {
    return {
      kind: "setup_required",
      title: "Bridge setup required",
      description: "The Orbit widget is installed, but this dashboard still needs the token function deployed.",
      detail: "Deploy supabase/functions/orbit-bridge-token and set VITE_ORBIT_BRIDGE_TOKEN_ENDPOINT.",
      actionLabel: "Retry after deploy",
    };
  }
  if (raw.includes("origin_not_allowed") || raw.includes("origin not allowed") || raw.includes("403")) {
    return {
      kind: "setup_required",
      title: "Origin not allowed",
      description: "Orbit can see this dashboard, but this browser origin is not allowed for the tenant yet.",
      detail: "Add this dashboard URL to Allowed origins in Orbit Bridge settings, then refresh.",
      actionLabel: "Retry after update",
    };
  }
  if (raw.includes("401") || raw.includes("jwt_invalid")) {
    return {
      kind: "session",
      title: "Session check failed",
      description: "Orbit could not verify your signed-in dashboard session yet.",
      detail: "Refresh the dashboard or sign in again, then retry.",
      actionLabel: "Retry",
    };
  }
  return {
    kind: "unknown",
    title: "Orbit connection failed",
    description: "Orbit could not finish the bridge handshake for this dashboard.",
    detail: clean,
    actionLabel: "Retry",
  };
}
